(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      eInvoicesModal: {
        "headerLabel": "Plaćanje eRačuna",
        "instructionLabel": "Odaberite datum naloga i potvrdite plaćanje",
        "issuerLabel": "Nalogodavac:",
        "purposeLabel": "Opis plaćanja:",
        "amountLabel": "Iznos:",
        "refNumberLabel": "Poziv na broj primatelja:",
        "paymentDateLabel": "Datum plaćanja",
        "today": "Današnji datum",
        "dueDate": "Rok za plaćanje",
        "otherDate": "Drugi datum",
        "btnCancel": "Odustani",
        "btnPay": "Plati eRačun",
        "subscribeOrCancel": "Pretplati se na novi eRačun ili otkaži postojeću pretplatu",
        "submitted": "Podneseni zahtjevi",
        "showIssued": "Prikaži eRačune izdane ",
        "showAuthorizedEinvoices": "Prikaži eRačune na ovlaštenim računima",
        "waitingForPayment": "Neplaćeni eRačuni",
        "payedAndRemoved": "Plaćeni i uklonjeni eRačuni",
        "loadMoreEinvoices":"Prikaži još eRačuna",
        "einvoices": "eRačuni",
        "view": "Prikaži",
        "pay": "Plati",
        "noData": "Za odabrani period nema podataka za prikaz",
        "fromAccountPayLabel": "Uplati s računa: ",
        "availableAmountLabel": "Raspoloživi iznos: ",
        "viewEinvoice": "Prikaži eRačun",
        "amountPlaceholder": "npr. 1.000,00",
        "btnSign": "Potpiši",
        "btnEdit": "Uredi",
        "signHeaderLabel": "Provjerite i potpišite eRačun",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primatelj",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "description": "Opis",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "enterComment": "Unesite komentar",
        "delete": "Izbriši",
        "edit": "Promijeni",
        "sign": "Potpiši",
        "listOfRegistrations":"Registrovani računi",
        "processedTab": "Obrađeni eRačuni",
        "processed": "Obrađeni eRačuni",
        "archived": "Arhivirani",
        "rejected": "Odbijeni",
        "noAvailableEInvoices": "Nema raspoloživih eRačuna",
        "creditorNameSearch": "Pretraga po nazivu kreditora"
      },
      eInvoiceDetail: {
        "attachments": "Privici",
        "eInvoicePDF": "eInvoice u PDF formatu",
        "eInvoiceXML": "eInvoice u XML formatu",
        "export": "Preuzimanje",
        "unsubscribeEInvoices": "Otkažite pretplatu na eRačun",
        "detail": "Detaljan pregled eRačuna",
        "unpaidInvoice": "Neplaćena faktura",
        "pay": "Plati",
        "markAsPayed": "Označi kao plaćeno/arhiviraj",
        "issuer": "Izdavatelj",
        "issuerAccount": "Račun izdavatelja",
        "purpose": "Svrha",
        "refNumber": "Poziv na broj primatelja",
        "amount": "Iznos",
        "issueDate": "Datum izdavanja",
        "purposeCode": "Šifra namjene",
        "dueDate": "Datum dospijeća",
        "digitalSignature": "Status digitalnog potpisa",
        "visibilityDigitalSignature": "Informacije o digitalnom potpisu",
        "signatureId": "ID potpisa",
        "digitalCertNumber": "Broj digitalnog certifikata",
        "signatureName": "Naziv potpisa",
        "certificateIssuer": "Izdavatelj digitalnog certifikata",
        "showInfo": "Prikaži ",
        "hideInfo": "Sakrij ",
        "recipient": "Primatelj",
        "recipientAccount": "Račun primatelja",
        "noAttachments": "eRačun nema priloga.",
        "goBack": "Povratak na eRačune",
        "issueDateOfEinvoice":"Datum eRačuna",
        "paymentDesc":"Opis plaćanja",
        "archive":"Arhiviraj",
        "showDigStatus":"Prikaži status digitalnog potpisa",
        "issuerIBAN":"IBAN izdavatelja",
        "placeOfReg":"Mjesto registracije",
        "dateOfReg":"Datum registracije",
        "cancelReg":"Otkaži registraciju",
        "cancel":"Odustani",
        "regAgain":"Registriraj ponovo",
        "rejectReason":"Razlog otkazivanja",
        "inProcess":"U obradi",
        "rejected":"Odbijen",
        "registered":"Registriran",
        "unregistered":"Neregistriran",
        "activeRegs":"Aktivne registracije",
        "cancelledRegs":"Otkazane registracije",
        "noteArchived": "Razlog arhiviranja",
        "noteRejected": "Razlog odbijanja",
        "serviceName": "Naziv usluge",
        "download": "Preuzmi PDF"
      },
      eInvoicesIssuersOverview: {
        "submittedApplications": "Aplikacije na koje ste pretplaćeni",
        "header": "Odaberi izdavatelja eRačuna",
        "issuerName": "Naziv izdavatelja",
        "issuerTaxId": "Porezni broj izdavatelja",
        "searchByNamePlaceholder": "Pretraži po nazivu",
        "searchByTaxIdPlaceholder": "Pretraži po poreznom broju",
        "showMore": "Prikaži još izdavatelja",
        "subscribe": "Pretplata",
        "issuerTax": "Porezni broj / Račun",
        "issuerAddress": "Adresa izdavatelja",
        "noData": "Za odabrani period nema podataka za prikaz"
      },
      eInvoicesSubscribe: {
        "goBack": "Povratak na prethodnu stranicu",
        "subscribeToEinvoice": "Pretplati se na eRačun",
        "einvoiceIssuer": "Izdavatelj eRačuna",
        "issuerAddress": "Adresa izdavatelja",
        "issuerAccount": "Račun izdavatelja",
        "referenceFromIssuer": "Poziv na broj",
        "einvoiceReceiver": "eInvoice receiver",
        "receiversName": "Receivers name",
        "receiversAddress": "Receivers address",
        "receiversTaxId": "Receivers Tax ID",
        "yourContactEmail": "e-mail",
        "tooltipInfo": "Trebate pomoć?",
        "tooltipInfoEmail": "Ukoliko radite promjenu emaila, ona se odnosi samo na registraciju usluge eRačun.",
        "einvoiceReferenceFromIssuerInputError": "Poziv na broj je obavezan!",
        "einvoiceSubscribeEmailInputError": "Vaš kontakt email je obavezan!",
        "reviewandSubmit": "Pregledajte i pošaljite",
        "changeEmail": "Promijeni email",
        "updateEmail": "Ažuriraj email",
        "cancel": "Odustani",
        "ok": "OK",
        "termsAndConditions": "Suglasan sam da računi više ne dolaze u papirnatom obliku",
        "specialConditions": "Prihvaćam posebne uvjete izdavatelja",
        "newRegistration": "Registracija eRačuna",
        "selectIssuer":"Izaberite izdavatelja",
        "registrationNew":"Nova registracija",
        "generalTerms":"Prihvaćam uvjete korištenja",
        "register":"Registriraj",
        "applicationComplete": "Zahtjev uspješan",
        "applicationCompleteText": "Uspješno ste poslali zahtjev za eRačun za izdavatelja {{name}}.",
        "goToList": "Povratak na eRačune",
        "einvoiceIssuerInputError": "Izdavatelj je obavezan podatak!"
      },
      eInvoiceRegistration: {
        listOfRegistrations: "Pregled registracija",
        "unregistered": "Otkazane",
        "rejected": "Odbijene",
        "registered": "Obrađene",
        "inProcess": "U obradi"
      },
      eInvoiceOverview:{
        "listOfEinvoices":"Lista eRačuna",
        "eInvoicesToPay":"eRačuni za platiti",
        "register":"Registracija eRačuna",
        "pay":"Plati",
        "success":"Uspješno!",
        "archivedEinvoces":"Arhivirani eRačuni",
        "successfulyArchived": "Uspješno ste arhivirali eRačun",
        "copy": "Kopiraj nalog",
        "inProgress": "U obradi"
      },
      eInvoicePayment: {
        "recAccount":"Račun primatelja",
        "purpose":"Svrha",
        "accNumber":"Broj računa",
        "toPayee":"Primatelj",
        "recAddress":"Adresa primatelja",
        "recPostalCity":"Poštanski kod i grad primatelja"
      },
      eInvoiceStatus:{
        "InProcess":"U obradi",
        "Unregistered":"Otkazana",
        "Registered":"Obrađena",
        "Rejected":"Odbijena"
      }
    };

    $translateProvider
      .translations('hr', data);
  }
}());
